import React, { useEffect, useState } from "react";
import MILogo from "../../images/MI-Image.png";
import { useLocation } from "react-router-dom";
import axios from "axios";

const OkDollarFail = () => {
  const location = useLocation();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = params.get("data");
    if (data) {
      const parsedData = JSON.parse(decodeURIComponent(data));
      console.log("Parsed DATA:", parsedData);
      setPaymentDetails(parsedData);

      // setPaymentDetails(data);
    }
  }, []);

  const handleBackToMerchantClick = async () => {
    setLoading(true);

    try {
      // Make an API call to the backend to get the URL and JSON response
      const response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/payments/backtomerchant`,
        {
          params: {
            invoiceNo: paymentDetails.invoiceNo, // Send invoiceNo as a query parameter
          },
          headers: {
            Authorization: `Bearer `,
          },
        }
      );

      // Extract data from the response
      const {
        backtoMerchantUrl,
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      } = response.data;

      // Create a form and append hidden input fields for each parameter
      const form = document.createElement("form");
      form.method = "POST";
      form.action = backtoMerchantUrl;

      const data = {
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      };

      // Create hidden input fields for each piece of data
      Object.keys(data).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      });

      // Append the form to the body and submit it
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error redirecting to merchant:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <pre>
        {paymentDetails?.status === "FAIL" ? (
          <div className="container mt-5">
            {/* Header Section */}
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <img
                  src={MILogo}
                  alt="Logo"
                  className="me-2" // Bootstrap class for margin-right
                  style={{
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>

            {/* Amount Section */}
            <div className="mt-3">
              <h5 className="text-primary m-0">Pay for Myanma Insurance</h5>
            </div>

            <div className="container mt-4">
              <h5>OK$ PAYMENT</h5>
            </div>

            {/* QR Payment Section */}
            <div className="mt-4">
              <div className="text-success d-flex justify-content-center align-items-center mt-3">
                <h3>Transaction {paymentDetails.invoiceNo} is Fail.</h3>
              </div>
            </div>

            {/* Instructions Section */}
            <div className="mt-4 text-center">
              <p>
                For any additional queries or help, please contact{" "}
                <u>it-support@thuriyaacetechnology.com</u>
              </p>
            </div>

            {/* Save QR Button */}
            <div className="text-center mt-5 mb-5">
              <button
                className="btn btn-primary"
                onClick={handleBackToMerchantClick}
                disabled={loading}
              >
                {loading ? "Redirecting..." : "BACK TO MERCHANT"}
              </button>
            </div>
          </div>
        ) : (
          "Loading..."
        )}
      </pre>
    </div>
  );
};

export default OkDollarFail;
